import Cookies from 'js-cookie';
import { chatService } from 'services/chat';
import useSWR from 'swr';

export const useUnreadMessagesCount = () => {
	const fetcher = async (): Promise<number> => {
		const accessToken = Cookies.get('accessToken');
		if (!accessToken) {
			return 0;
		}

		try {
			return await chatService.getUnreadMessagesCount();
		} catch (error) {
			console.error('Error fetching unread messages count:', error);
			return 0;
		}
	};

	const { data, error, isLoading, mutate } = useSWR<number>(
		'unread-messages-count',
		fetcher,
		{
			refreshInterval: 30000, // Refetch every 30 seconds
			revalidateOnFocus: true, // Refetch when user gets back to the tab
			revalidateOnReconnect: true, // Refetch when internet connection is restored
			dedupingInterval: 5000, // Dedupe requests within 5 seconds
			errorRetryCount: 3, // Retry 3 times on error
			errorRetryInterval: 5000, // Wait 5 seconds between retries
		}
	);

	return {
		unreadCount: data ?? 0,
		isLoading,
		error,
		mutate, // Expose mutate for manual refetching if needed
	};
}; 